module.exports = __webpack_public_path__ + "static/media/company-logo-color.695cdcfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/company-logo-color.png
// module id = 663
// module chunks = 0